var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav'),_c('main',{staticClass:"col-lg-10 col-md-9 col-sm-9 left_gutter main fill"},[_c('h1',[_vm._v("Needs to be Measured")]),_c('Container',{attrs:{"buildSchedule":_vm.dataState,"user":_vm.appState.user}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }